function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from "react";
import Svg from "../svg";
import ThListSvg from "../../assets/fonts/fa/svgs/light/th-list.svg";
import ListSvg from "../../assets/fonts/fa/svgs/light/list.svg";
import Th from "../../assets/fonts/fa/svgs/solid/th.svg";
export var LayoutModesEnum;
(function(LayoutModesEnum) {
    LayoutModesEnum["Table"] = "table";
    LayoutModesEnum["List"] = "list";
    LayoutModesEnum["Grid"] = "grid";
})(LayoutModesEnum || (LayoutModesEnum = {}));
var _obj;
export var LAYOUT_MODES = (_obj = {}, _defineProperty(_obj, LayoutModesEnum.Table, {
    iconComponent: /*#__PURE__*/ React.createElement(Svg, {
        src: ThListSvg
    })
}), _defineProperty(_obj, LayoutModesEnum.List, {
    iconComponent: /*#__PURE__*/ React.createElement(Svg, {
        src: ListSvg
    })
}), _defineProperty(_obj, LayoutModesEnum.Grid, {
    iconComponent: /*#__PURE__*/ React.createElement(Svg, {
        src: Th
    })
}), _obj);
